import * as React from "react";

import { connect } from "react-redux";

import { isRequestActive } from "redux-request-loading";

import { DashboardIcon } from "@teamprevent/common/dashboard";

import { ActionableTasksListModel } from "../../actionableTask";
import { ApplicationState } from "../../applicationState";

import { LOAD_ACTIONABLE_TASKS } from "../../actionableTask/actionTypes";

interface StateProps {
    tasks: ActionableTasksListModel[];
    loading: boolean;
}

class Actions extends React.Component<StateProps> {
    public render() {
        return (
            <DashboardIcon href="/actions" icon="/assets/actions.svg" label="Notifications" count={this.props.tasks.length} />
        );
    }
}

function mapStateToProps(state: ApplicationState) {
    return {
        tasks: state.actionableTasks,
        loading: isRequestActive(state, LOAD_ACTIONABLE_TASKS)
    };
}

export default connect(mapStateToProps)(Actions);
